// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","mobile":"screen and (max-width: 600px)","label":"label-OlOjt","container":"container-2mLtW"};